export const SET_CURRENT_INVITATION = "invitation/SET_CURRENT_INVITATION";
export const CLEAN_INVITATION = "invitation/CLEAN_INVITATION";
